import { Injectable } from '@angular/core';
import {
  TimelineNode,
} from '@shared/models/analysis-timeline.model';

/**
 * Service for building and managing analysis timeline logic.
 * @deprecated This service uses the old status model and will be replaced
 * by the new technical-stage based timeline in the analysis-timeline component.
 */
@Injectable({
  providedIn: 'root',
})
export class AnalysisTimelineService {
  buildTimelinePath(
    currentStatus: string,
    statusHistory: { status: string; changedAt: Date }[],
  ): TimelineNode[] {
    return [];
  }

  wasStatusVisited(status: string, statusHistory: { status: string }[]): boolean {
    return statusHistory.some((h) => h.status === status);
  }

  getStatusTimestamp(
    status: string,
    statusHistory: { status: string; changedAt: Date }[],
  ): Date | undefined {
    return statusHistory.find((h) => h.status === status)?.changedAt;
  }

  determineNodeState(
    status: string,
    currentStatus: string,
    statusHistory: { status: string }[],
  ): TimelineNode['state'] {
    if (status === currentStatus) return 'current';
    if (this.wasStatusVisited(status, statusHistory)) return 'completed';
    return 'upcoming';
  }

  formatDate(date: Date | undefined): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
